// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3668ea72","455":"9e721f08","977":"f03c811f"}[chunkId] + ".chunk.js";
};